<template>
  <div v-wechat-title="$store.state.html_title || $route.meta.title">
    <Panel :class="{'on': on }" v-show="no_header" @change="change"></Panel>
    <Header :class="{'on': on }" v-show="no_header" @change="change" :on="on"></Header>
    <div class="container" :class="{'on': on, 'no-header': !no_header }">
      <keep-alive>
          <router-view :key="activeDate" v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view :key="activeDate" v-if="!$route.meta.keepAlive"/>
    </div>
  </div>
</template>

<script>
import { user_mixin } from 'mobile/js/user_mixin'
import { createThemeTypeOrder } from './service'
import Header from '@/views/Mobile/components/header.vue'
import Panel from '@/views/Mobile/components/panel.vue'
import moment from 'moment'
const no_header_list = ['MNotFound', 'MNewsList',
                        'MNewsDetail', 'MAttentionIndex',
                        'MOrgDetail', 'MCompanyDetail',
                        'MCompanyCompare', 'MPeoDetail',
                        'MFinancingIndex', 'MShareTimeLine',
                        'MBriefReport','MSanten','MNewsletter', 'MEventList',
                        'MMergersList','MCompanyList',
                        'MOrgList','MHospitalList',
                        'MHospitalDetail','MPolicyList',
                        'MSearchList',
                        'MReportList','MReportDetail',
                        'MUserReport','MOrderList',
                        'MOpenInv','MBuyVip','MUserAccount', 'MNotOpen',
                        'MUserMain', 'MPreviewBriefReport', 'MShareMap', 'MShareTable', 'MShareScatter',
                        'MCollectInfo','MPayStatus','MBuyInfo','MLogin','MLogin2', 'VipExperience', 'MExperienceSuccess',
                        'MShareScatterWx', 'MShareMapWx', 'MShareTimeLineWx', 'MShareTableWx',
                        'MIndex','MLog','MHelpCenter','MAbout','MWorkBench','MFeedList', 'contact', 'MApplyTest', 'MApplySuccess']
export default {
  mixins: [user_mixin],
  provide() {
    return {
      reload: this.reload,
      goBuy: this.goBuy
    }
  },
  data() {
    return {
      activeDate: moment().unix(),
      on: false,
      order_actions: {
        'theme_type_id': createThemeTypeOrder
      }
    }
  },
  computed: {
    no_header: function(){ // 页面是否需要header
      // console.log(this.$route)
      return no_header_list.indexOf(this.$route.name) == -1 ? true : false
    }
  },
  components: {
    Header,
    Panel
  },
  methods: {
    reload(cb){
      this.activeDate = moment().unix()
      this.$nextTick(() => {
        if (cb) {
          cb
        }
      })
    },
    change() { // 是否显示抽屉
      this.on = !this.on
    },
    // 是否执行购买流程(create_order_key:创建订单需要的key，create_order_value:创建订单需要的value,buy_type:购买类型,url：购买回调地址)
    async goBuy(create_order_key,create_order_value,buy_type,url) {
      if (this.$store.state.user_key) {
        if (!this.user.name || !this.user.comp_name || !this.user.title) { // 去完善信息
          // this.$router.push({name: 'MCollectInfo',query: {[create_order_key]: create_order_value, type: buy_type, url: Buffer(url).toString('base64')}})
          this.$router.push({name: 'MCollectInfo',query: {[create_order_key]: create_order_value, type: buy_type, url: escape(url)}})
        } else { //  去订单详情
          let res = await this.order_actions[create_order_key]({
            user_key: this.$store.state.user_key,
            [create_order_key]: create_order_value
          })
          if (res.status == 'success') {
            // this.$router.push({name: 'MBuyInfo',params: {order_uid: res.order_uid, type: buy_type}, query: { url: Buffer(url).toString('base64')}})
            this.$router.push({name: 'MBuyInfo',params: {order_uid: res.order_uid, type: buy_type}, query: { url: escape(url)}})
          } else {
            this.$Message.error(res.message)
          }
        }
      } else { //  去登录
        // this.$router.push({name: 'MLogin',query: {action: 'buy', [create_order_key]: create_order_value, type: buy_type, url: Buffer(url).toString('base64')}})
        this.$router.push({name: 'MLogin',query: {action: 'buy', [create_order_key]: create_order_value, type: buy_type, url: escape(url)}})
      }
    }
  }
}
</script>
<style lang="stylus">
@import '../../assets/mobile/styles/common.stylus'
.container
  padding-top: 1rem;
  transition: all .3s;
  -webkit-overflow-scrolling : touch;
  &.on
    transform: translateX(-3.2rem);
  &.no-header
    padding-top: 0;
</style>
